// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T3Jf","colBig":"styles_colBig__QIdYU","colSmall":"styles_colSmall__2ljf-"};